import { Inline, Radio, RadioGroup, Stack } from '@etg/wings';
import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { GenderInput } from '@eti/schema-types';
import { ConnectedRadioGroup } from '@eti/form';
import { constants, persistInputData } from '@eti/utils';
import { GENDER } from '../../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const ChildrenInput = {
  Boy: 'Boy',
  Girl: 'Girl'
};
const Gender = _ref => {
  let {
    form,
    id,
    isAdult,
    isReadOnly,
    headingId
  } = _ref;
  const {
    p
  } = useProperty();
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    isSnowplowTrackingEnabled,
    sendTrackEvent
  } = useSnowplowTracking();
  const name = `${GENDER}-${id}`;
  const handleOnGenderChange = (_event, value) => {
    if (p('IbeClient.TravelerDetails.PersistFormData.Enabled')) {
      persistInputData(form, name)(value);
    }
    const isMale = value === GenderInput.Male;
    const maleValue = isAdult && isMale ? GenderInput.Male : ChildrenInput.Boy;
    const femaleValue = isAdult && value === GenderInput.Female ? GenderInput.Female : ChildrenInput.Girl;
    const eventValue = isMale ? maleValue : femaleValue;
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Select',
        label: 'Gender',
        property: eventValue.toLowerCase(),
        value: parseInt(id, 10) + 1
      });
    }
  };
  const femaleLabel = t(`TravelerForm.${isAdult ? 'GenderFemale' : 'GenderGirl'}.Label`);
  const maleLabel = t(`TravelerForm.${isAdult ? 'GenderMale' : 'GenderBoy'}.Label`);
  const radioGroupLegend = nonDebugT('Input.Field.Required', t('TravelerForm.Gender.Label'));
  return /*#__PURE__*/_jsx(ConnectedRadioGroup, {
    "aria-label": `${t('Validation.Gender.Required')} ${t('Validation.Required')}`,
    "data-testid": `travelerDetails-Gender-${id}-input`,
    isDisabled: isReadOnly,
    name: name,
    onChange: handleOnGenderChange,
    validationRuleName: GENDER,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 8,
      children: [/*#__PURE__*/_jsx(RadioGroup.Legend, {
        id: `${headingId}-description`,
        children: radioGroupLegend
      }), /*#__PURE__*/_jsxs(Inline, {
        className: MOUSE_FLOW_CLASS_NAMES,
        spacing: 24,
        children: [/*#__PURE__*/_jsx(Radio.Label, {
          "data-testid": `travelerDetails-male-${id}-label`,
          htmlFor: `male-${id}`,
          children: /*#__PURE__*/_jsxs(Inline, {
            alignY: "center",
            spacing: 8,
            children: [/*#__PURE__*/_jsx(Radio, {
              id: `male-${id}`,
              name: name,
              value: GenderInput.Male
            }), maleLabel]
          })
        }, `${name}-male-${id}`), /*#__PURE__*/_jsx(Radio.Label, {
          "data-testid": `travelerDetails-female-${id}-label`,
          htmlFor: `female-${id}`,
          children: /*#__PURE__*/_jsxs(Inline, {
            alignY: "center",
            spacing: 8,
            children: [/*#__PURE__*/_jsx(Radio, {
              id: `female-${id}`,
              name: name,
              value: GenderInput.Female
            }), femaleLabel]
          })
        }, `${name}-female-${id}`)]
      })]
    })
  });
};
export default Gender;
//# sourceMappingURL=Gender.js.map